import React, { useState, useEffect } from "react";
import NavBar from "../../components/layout/NavBar";
import Footer from "../../components/layout/Footer";
import StaffFinanceiro from "../../components/staff/StaffFinanceiro";
import StaffUsuarios from "../../components/staff/StaffUsuarios";
import StaffTaxas from "../../components/staff/StaffTaxas";
import { ShieldCheck, DollarSign, Users, Lock, Home } from "lucide-react";
import { Button } from "../../components/ui/Button";

function StaffDashboard() {
  const [activeTab, setActiveTab] = useState("financeiro");
  const [userName, setUserName] = useState("Staff");
  const [isAuthorized, setIsAuthorized] = useState(true);

  useEffect(() => {
    const tipoUser = String(sessionStorage.getItem("brv-tipo-user") || "").toLowerCase();
    const nome = sessionStorage.getItem("brv-user") || "Staff";
    setUserName(nome);

    // Verifica permissão (se tipo_usuario tiver 'staff')
    if (tipoUser && !tipoUser.includes("staff")) {
      setIsAuthorized(false);
    } else {
      setIsAuthorized(true);
    }
  }, []);

  const tabs = [
    {
      id: "financeiro",
      label: "Financeiro Urbrace",
      icon: <DollarSign className="w-4 h-4" />
    },
    {
      id: "usuarios",
      label: "Usuários da Plataforma",
      icon: <Users className="w-4 h-4" />
    },
    {
      id: "taxas",
      label: "Taxas por Corrida (R$)",
      icon: <DollarSign className="w-4 h-4" />
    }
  ];

  if (!isAuthorized) {
    return (
      <div className="min-h-screen bg-urb-bg text-urb-text flex flex-col justify-between">
        <header>
          <NavBar />
        </header>
        <main className="max-w-2xl mx-auto px-4 py-16 flex flex-col items-center justify-center text-center gap-4">
          <div className="w-16 h-16 rounded-full flex items-center justify-center bg-red-500/10 border border-red-500/30">
            <Lock className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-2xl font-bold text-white tracking-tight">
            Acesso Restrito ao Staff Urbrace
          </h2>
          <p className="text-urb-text-muted text-sm max-w-md">
            Sua conta atual não possui permissões administrativas para visualizar este painel.
          </p>
          <Button
            variant="primary"
            size="md"
            className="mt-4 gap-2 font-bold"
            onClick={() => window.location.replace("/")}
          >
            <Home className="w-4 h-4" />
            <span>Ir para a Página Inicial</span>
          </Button>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-urb-bg text-urb-text flex flex-col justify-between">
      <header>
        <NavBar />
      </header>

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 py-6 flex flex-col gap-6">
        {/* Header Superior do Staff */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <h1 className="text-2xl sm:text-3xl font-black text-white tracking-tight">
                Painel Staff Urbrace
              </h1>
              <ShieldCheck className="w-6 h-6 text-urb-primary shrink-0" />
            </div>
            <p className="text-sm text-urb-text-muted">
              Olá, <span className="text-white font-semibold">{userName}</span>. Gestão financeira, controle de usuários e configuração de taxas.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider flex items-center gap-2 bg-urb-primary/10 text-urb-primary border border-urb-primary/30">
              <span className="w-1.5 h-1.5 rounded-full bg-urb-primary" />
              Acesso Master
            </span>
          </div>
        </div>

        {/* Abas de Navegação Personalizadas */}
        <div className="flex items-center gap-2 p-1.5 bg-urb-card border border-urb-border rounded-xl overflow-x-auto shadow-sm">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap border ${
                  isActive
                    ? "bg-urb-primary text-black border-urb-primary shadow-md font-bold"
                    : "text-slate-400 hover:text-white bg-transparent border-transparent"
                }`}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>

        {/* Conteúdo Dinâmico da Aba Selecionada */}
        <div className="w-full">
          {activeTab === "financeiro" && <StaffFinanceiro />}
          {activeTab === "usuarios" && <StaffUsuarios />}
          {activeTab === "taxas" && <StaffTaxas />}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default StaffDashboard;
